{
    "sidebar": {
        "dashboard": "Dashboard",
        "engage": "Engage",
        "contacts": "Contacts",
        "commerce": "Commerce",
        "reach": "Reach",
        "automate": "Automate",
        "settings": "Settings",
        "aiAgents": "AI Agents"
    },
    "channels": {
        "ig": "Instagram",
        "allWa": "WhatsApp",
        "ecommerce": "Ecommerce",
        "waQr": "WhatsApp QR",
        "waBusiness": "WhatsApp Business",
        "fbMessenger": "Messenger",
        "facebook": "Facebook",
        "livechat": "Livechat"
    }
}
